import React from 'react'

export default function Locate() {
    return (
        <div>
            <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M25 9.375V5.46875M25 44.5312V40.625" stroke="#BB0600" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M25 10.9375C22.2187 10.9375 19.4999 11.7623 17.1873 13.3075C14.8747 14.8527 13.0723 17.0489 12.008 19.6185C10.9436 22.1881 10.6651 25.0156 11.2077 27.7435C11.7503 30.4713 13.0896 32.977 15.0563 34.9437C17.023 36.9104 19.5287 38.2497 22.2565 38.7923C24.9844 39.3349 27.8119 39.0564 30.3815 37.9921C32.9511 36.9277 35.1473 35.1253 36.6925 32.8127C38.2378 30.5001 39.0625 27.7813 39.0625 25C39.0625 21.2704 37.5809 17.6935 34.9437 15.0563C32.3065 12.4191 28.7296 10.9375 25 10.9375Z" stroke="#BB0600" stroke-width="4" stroke-miterlimit="10" />
                <path d="M40.625 25H44.5312M5.46875 25H9.375" stroke="#BB0600" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

        </div>
    )
}
